/**
 * API Configuration
 * This file contains all API-related configuration settings.
 * Update this file to change API endpoints across the application.
 */

// Detect environment and use appropriate configuration
const isRailway = process.env.REACT_APP_RAILWAY === "true";
const browserHost = window.location.hostname || "localhost";
const browserProtocol = window.location.protocol
  ? window.location.protocol.slice(0, -1)
  : "http";

export const API_CONFIG = {
  HOST: browserHost,
  PORT: isRailway ? "" : "8012",
  PROTOCOL: browserProtocol,
};

// Base API URL
export const API_BASE_URL = API_CONFIG.PORT
  ? `${API_CONFIG.PROTOCOL}://${API_CONFIG.HOST}:${API_CONFIG.PORT}/api`
  : `${API_CONFIG.PROTOCOL}://${API_CONFIG.HOST}/api`;

// Server base URL (without /api path)
export const SERVER_BASE_URL = API_CONFIG.PORT
  ? `${API_CONFIG.PROTOCOL}://${API_CONFIG.HOST}:${API_CONFIG.PORT}`
  : `${API_CONFIG.PROTOCOL}://${API_CONFIG.HOST}`;

// API Endpoints
export const API_ENDPOINTS = {
  // Option Chain
  OPTION_CHAIN: "/option-chain",

  // Orders
  ORDERS: "/orders",
  PLACE_ORDER: "/orders",
  ORDER_HISTORY: "/orders/history",
  CHARGES_SUMMARY: "/orders/charges/summary",
  ORDERS_REFRESH: "/orders/refresh",
  ORDERS_WITH_RISK: "/orders/with-risk",

  // Failed Orders (Retry mechanism)
  FAILED_ORDERS: "/failed-orders",
  RETRY_ORDER: "/retry-order",

  // Entries (Trade-level risk management)
  ENTRIES: "/entries",
  ENTRIES_CREATE_FROM_ORDER: "/entries/create-from-order",

  // Positions
  POSITIONS: "/positions",
  PORTFOLIO: "/portfolio",
  DUMMY_POSITIONS: "/dummy-positions",
  ENTRY_POSITIONS: "/positions/entries",

  // Funds and Margins
  FUNDS: "/funds",

  // PNL - DISABLED
  // LATEST_PNL: '/pnl/latest',

  // General settings and metadata
  GENERAL: "/general",

  // Expiries
  EXPIRIES: "/expiries",
  SETTINGS: "/settings",

  // Derived Data
  DERIVED_DATA_LATEST: "/derived-data/latest",
  DERIVED_DATA_SUMMARY: "/derived-data/summary",
  DERIVED_DATA_ATM_STATS: "/derived-data/atm-stats",

  // Trading Stats (combined ATM + min/max PnL)
  TRADING_STATS: "/trading-stats",
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => `${API_BASE_URL}${endpoint}`;

// Default request headers
export const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
};

// API request timeout in milliseconds
export const REQUEST_TIMEOUT = 30000;

const apiConfig = {
  API_CONFIG,
  API_BASE_URL,
  SERVER_BASE_URL,
  API_ENDPOINTS,
  getApiUrl,
  DEFAULT_HEADERS,
  REQUEST_TIMEOUT,
};

export default apiConfig;
